const state = {
    UserItems: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 100,
            filter: {
                id: '',
                name: '',
                email: '',
                organization: '',
                phone: '',
                address_line: ''
            }
        },
    },
    user: null,
    Loadings: {
        list: false
    },
    passwordManagement: null
};

const getters = {
    ListingUser: (state) => state.UserItems,
    Loadings: (state) => state.Loadings,
    IteamUser: (state) => state.user,
    PasswordManagement: (state) => state.passwordManagement,
};

const actions = {

    async getListUser({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`/api/users`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    response.data.data.pages = params
                    commit('setLoadings', { key: "list", val: false });
                    commit('setListingUser', response.data.data)
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getListUser2({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`/api/users`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "list", val: false });
                    reject(error)
                });
        });
    },
    async searchListUser({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        let request_params = {
            limit: params.limit || 50,
            page: params.page || 1,
            filter: params.filters,
        }

        if(params.allow_roles) {
            request_params.allow_roles = params.allow_roles
        }
        if(params.safety_allow_fm_role_for_duty_supplier) {
            request_params.safety_allow_fm_role_for_duty_supplier = params.safety_allow_fm_role_for_duty_supplier
        }
        return new Promise((resolve, reject) => {
            global.axios(`/api/users`, {
                    method: "GET",
                    params: request_params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    let data = {
                        data: response.data.data.items,
                        total: response.data.data.total,
                        currentPage: params.page,
                        limit: params.limit || 50,
                        filter: params.filters
                    }
                    commit('setLoadings', { key: "list", val: false });
                    resolve(data);
                })
                .catch(error => reject(error));
        });
    },

    async getAccessFmUsers({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/access`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

    async getAccessRunsheetFmUsers({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/access-runsheet`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

    async SaveUser({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        let formData = new FormData();
        formData.append('name', params.name || '');
        formData.append('organisation_id', params.organisation_id || '');
        formData.append('email', params.email || '');
        formData.append('password', params.password || '');
        formData.append('contract_id', params.contract_id || '');
        formData.append('property_id', params.property_id || '');
        formData.append('preferred_contact_mode', params.preferred_contact_mode || '');
        formData.append('mailing_address_id', params.mailing_address_id || '');
        formData.append('mailing_address_id_tmp', params.mailing_address_id_tmp || '');
        formData.append('billing_address_id', params.billing_address_id || '');
        formData.append('billing_address_id_tmp', params.billing_address_id_tmp || '');
        formData.append('department', params.department || '');
        formData.append('designation', params.designation || '');
        formData.append('active', params.active || '');
        formData.append('attachment_id', params.attachment_id || '');
        formData.append('attachment_file', params.attachment || '');
        formData.append('address', params.address ? JSON.stringify(params.address) : '');
        formData.append('role', params.role ? JSON.stringify(params.role) : '');
        formData.append('microsoft2fa_enable', params.microsoft2fa_enable || false);
        formData.append('gofix_projects', params.gofix_projects ? JSON.stringify(params.gofix_projects) : '');
        formData.append('is_safety', params.is_safety ? params.is_safety : false);
        if(params.contract_ids) {
            formData.append('contract_ids', JSON.stringify(params.contract_ids));
        }

        return new Promise((resolve, reject) => {
            global.axios(`/api/users`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    if (!response.data.data.code) {
                        commit('setUser', response.data.data)
                        commit('updateListingUser', response.data.data);
                    }

                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "list", val: false });
                    reject(error.response.data)
                });
        });
    },
    async updateUser({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        let formData = new FormData();
        formData.append('name', params.name || '');
        formData.append('organisation_id', params.organisation_id || '');
        formData.append('email', params.email || '');
        formData.append('password', params.password || '');
        formData.append('contract_id', params.contract_id || '');
        formData.append('property_id', params.property_id || '');
        formData.append('preferred_contact_mode', params.preferred_contact_mode || '');
        formData.append('mailing_address_id', params.mailing_address_id || '');
        formData.append('mailing_address_id_tmp', params.mailing_address_id_tmp || '');
        formData.append('billing_address_id', params.billing_address_id || '');
        formData.append('billing_address_id_tmp', params.billing_address_id_tmp || '');
        formData.append('department', params.department || '');
        formData.append('designation', params.designation || '');
        formData.append('active', params.active || '');
        formData.append('microsoft2fa_enable', params.microsoft2fa_enable || false);
        formData.append('attachment_id', params.attachment_id || '');
        formData.append('attachment_file', params.attachment || '');
        formData.append('address', params.address ? JSON.stringify(params.address) : '');
        formData.append('role', params.role ? JSON.stringify(params.role) : '');
        formData.append('gofix_projects', params.gofix_projects ? JSON.stringify(params.gofix_projects) : '');
        if(params.is_safety) {
            formData.append('is_safety', params.is_safety ? params.is_safety : false);
        }
        if(params.contract_ids) {
            formData.append('contract_ids', JSON.stringify(params.contract_ids));
        }

        return new Promise((resolve, reject) => {
            global.axios(`/api/users/${params.id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('editListingUser', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "list", val: false });
                    if(error.response && error.response.data) {
                        reject(error.response.data)
                    }
                    reject(error)
                });
        });
    },
    async deleteUser({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`/api/users`, {
                    method: "DELETE",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    //commit('deleteUser', params)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getUser({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/${params}`, {
                    method: "get",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setItemUser', response.data.data)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getUserSuper({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/super`, {
                    method: "get",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async checkUser({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/check-existed/`, {
                    method: "get",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async restoreUser({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/restore`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setUser', response.data.data)
                    commit('updateListingUser', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "list", val: false });
                    reject(error.response.data)
                });
        });
    },

    /*Password Management*/
    async getPasswordManagement({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/password-settings`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('passwordManagement', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updatePasswordManagement({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/password-settings`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('passwordManagement', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data)
                });
        });
    },
    async checkPasswordExpired({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/check-password-expired`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async changePasswordExpired({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/change-password`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    //commit('passwordManagement', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data)
                });
        });
    },
    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/users/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // Export User Access
    async exportUserAccess({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/roles/user-access`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => reject(error))
        });
    },
    async import({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImport);
            formData.append('contract_id',params.id);
            commit( 'setLoading', {key:'import',val:true} );
            global.axios.post(`/api/users/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setLoading', {key:'import',val:false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoading', {key:'import',val:false} );
                    reject( error )
                } );
        });
    },
};

const mutations = {
    passwordManagement(state, data) {
        state.passwordManagement = data;
    },
    setListingUser(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit);
        state.UserItems.data = data.items;
        state.UserItems.total = data.total;
        state.UserItems.pages = data.pages;
    },
    setItemUser(state, data) {
        state.user = data
    },
    updateListingUser(state, user) {
        state.UserItems.data = [...state.UserItems.data, user];
    },
    editListingUser(state, user) {
        if (state.UserItems.data) {
            state.UserItems.data = state.UserItems.data.map(item => item.id === user.id ? user : item)
        }
    },
    setLoadings(state, data) {
        if (data.key === "list") {
            state.Loadings.list = data.val;
        }
    },
    deleteUser(state, data) {
        state.UserItems.data = state.UserItems.data.filter(function(obj) {
            return !data.some(function(obj2) {
                return obj.id == obj2;
            });
        });
    },
    setUser(state, data) {
        state.user = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}